/** Segundos a mm:ss, nunca negativo. */
export function mmss(seconds: number): string {
  const safe = Math.max(0, Math.round(seconds))
  const minutes = Math.floor(safe / 60)
  return `${String(minutes).padStart(2, '0')}:${String(safe % 60).padStart(2, '0')}`
}

/** Dos dígitos: los segundos sueltos de los intervalos. */
export function ss(seconds: number): string {
  return String(Math.max(0, Math.round(seconds))).padStart(2, '0')
}

/** Minutos redondeados, para las estimaciones de duración. */
export function minutes(seconds: number): number {
  return Math.round(seconds / 60)
}

export const clamp = (value: number, min: number, max: number): number =>
  Math.min(max, Math.max(min, value))

/** Fecha corta en castellano: "3 de agosto". */
export function longDate(iso: string): string {
  return new Date(iso).toLocaleDateString('es-ES', { day: 'numeric', month: 'long' })
}
